import Request from '@request/Request';

export default class extends Request {
  constructor(ref, data) {
    data = {
      id: '',
      tour_id: '',
      reported_at: '',
      species: [],
      attendees: [],
      amount: '',
      ...data,
    };
    super(ref, data);
  }

  /*
  Function to check if given species count for sighting attendee already exist
   */
  hasSpeciesSightingsData(memberID, speciesID) {
    if (!this.species || !this.species.length) {
      return false;
    }
    return this.species.find(
      (attendee) =>
        attendee.species_id === speciesID && attendee.member_id === memberID
    );
  }

  changeSightingsData(member, species, increment = 1) {
    let speciesSightingsData = this.hasSpeciesSightingsData(
      member.id,
      species.id
    );
    if (speciesSightingsData) {
      if (speciesSightingsData.count === 1 && increment < 1) {
        this.species = this.species.filter(
          (attendee) =>
            attendee.member_id !== member.id ||
            attendee.species_id !== species.id
        );
        return;
      }
      speciesSightingsData.count += increment;
    } else {
      if (increment < 1) {
        return;
      }
      this.species.push({
        member_id: member.id,
        member: member,
        species_id: species.id,
        species: species,
        count: increment,
      });
    }
  }

  getCount(memberID, speciesID) {
    let speciesSightingsData = this.hasSpeciesSightingsData(
      memberID,
      speciesID
    );
    if (speciesSightingsData) {
      return speciesSightingsData.count;
    }
    return '';
  }

  getGlobalPrice(memberID, speciesID, operatorID) {
    let speciesSightingsData = this.hasSpeciesSightingsData(
      memberID,
      speciesID
    );
    const cost = this._getValidCost(speciesSightingsData, operatorID);

    if (speciesSightingsData) {
      return '$' + speciesSightingsData.count * cost;
    }
    return '';
  }

  _getValidCost(speciesSightingsData, operatorID) {
    if (!speciesSightingsData) {
      return null;
    }

    if (operatorID) {
      const price = speciesSightingsData.species.prices.find(
        (price) => price.user_id === operatorID
      );
      if (price) {
        return price.amount;
      }
    }

    return speciesSightingsData.species.cost;
  }

  getTotalPrice() {
    let self = this;
    let totalAmount = 0;
    self.species.forEach((item) => {
      let cost = item.count * item.species.cost;
      totalAmount += parseInt(cost);
    });
    this.amount = totalAmount;
    return totalAmount;
  }

  async getCheckoutDetails(trip_id) {
    let url = `custom-trips/${trip_id}/checkout/details`;
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-groups'
      )
    );
  }
}
